import { useState } from 'react';

import { Button, CheckboxField, Modal, Text, TipMessage } from '../../common/components';
import { useAppDispatch } from '../../common/hooks';
import { t } from '../../common/i18n';
import { setFlashMessage } from '../../common/store/uiSlice';
import { downloadPollMinutes } from '../services/PollService';

interface PollMinutesModalProps {
  pollId: string;
  isShown: boolean;
  onHide: () => void;
}

/**
 * Stažení zápisu z hlasování per rollam (PDF). Jmenný přehled hlasování jednotek je volitelná
 * příloha — zápis se typicky rozesílá / vyvěšuje všem vlastníkům, proto je ve výchozím stavu vypnutá.
 */
export const PollMinutesModal: React.FC<PollMinutesModalProps> = (props) => {
  const namespace = 'Poll.Results.Minutes';

  const dispatch = useAppDispatch();
  const [withVoterList, setWithVoterList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    setIsLoading(true);
    downloadPollMinutes(props.pollId, withVoterList)
      .then(() => props.onHide())
      .catch(() => dispatch(setFlashMessage({ message: t('error', namespace), type: 'error' })))
      .finally(() => setIsLoading(false));
  };

  return (
    <Modal isShown={props.isShown} onHide={props.onHide} enableOutsideClose>
      <Text size="h2" align="center" className="mb-2">
        {t('title', namespace)}
      </Text>
      <Text size="body-medium" align="center" color="Neutral700" className="mb-4">
        {t('text', namespace)}
      </Text>

      <CheckboxField
        name="withVoterList"
        label={t('withVoterList', namespace)}
        checked={withVoterList}
        onChange={(e) => setWithVoterList(e.target.checked)}
        className="mb-2"
      />
      <TipMessage className="mb-2">{t('voterListTip', namespace)}</TipMessage>
      <TipMessage className="mb-4">{t('signTip', namespace)}</TipMessage>

      <div className="Flex FlexColumn FlexAlign--center">
        <Button
          title={t('submit', namespace)}
          iconBefore="document"
          onClick={handleDownload}
          loading={isLoading}
          wide
        />
      </div>
    </Modal>
  );
};
